import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PageLoader } from '../components/common/Loading'
import { useAuth } from '../features/auth/AuthContext'

export default function ProtectedRoute() {
  const { isAuthenticated, isInitializing } = useAuth()
  const location = useLocation()

  if (isInitializing) return <PageLoader />
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />

  return <Outlet />
}
